import type {
  CreditCardScannerConfiguration,
  CreditCardScannerScreenConfiguration,
  ImageInput,
  ResultWrapper,
} from '../types';
import {
  CreditCardScannerUiResult,
  CreditCardScanningResult,
  handleImageInput,
  mapRTUUIResult,
  withSBErrorHandling,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotCreditCardImpl = {
  async scanFromImage(params: {
    image: ImageInput;
    configuration: CreditCardScannerConfiguration;
  }): Promise<CreditCardScanningResult> {
    return withSBErrorHandling(
      async () =>
        new CreditCardScanningResult(
          await ScanbotSDKPlugin.scanCreditCardFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
          }),
        ),
    );
  },

  async startScanner(
    configuration: CreditCardScannerScreenConfiguration,
  ): Promise<ResultWrapper<CreditCardScannerUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<CreditCardScannerUiResult>(
        await ScanbotSDKPlugin.startCreditCardScanner(configuration),
        CreditCardScannerUiResult,
      ),
    );
  },
};
